import { render, staticRenderFns } from "./wxScanBind.vue?vue&type=template&id=0110bf3b"
import script from "./wxScanBind.vue?vue&type=script&lang=js"
export * from "./wxScanBind.vue?vue&type=script&lang=js"
import style0 from "./wxScanBind.vue?vue&type=style&index=0&id=0110bf3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports